module.exports = __webpack_public_path__ + "img/videoStart.0315a424.svg";